module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai92-2fb7dee7974a0b52691ba2a4392f33fb.jpg";